import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../interactions/interactions';
import css from './control-expand.css';

const ControlExpand = ({
  ariaLabel,
  disabled,
  disc,
  handleClick,
  ...otherProps
}) => (
  <button
    className={classnames(css['ds-control-expand'], {
      [css['ds-control-expand--disc']]: disc,
    })}
    onClick={handleClick}
    aria-label={ariaLabel}
    disabled={disabled}
    type='button'
    {...otherProps}
  >
    <svg viewBox='5 5 14 14' xmlns='http://www.w3.org/2000/svg'>
      <path
        className={classnames(css['path-background'], {
          [css['path-background--disabled']]: disabled,
        })}
        d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'
      />
    </svg>
  </button>
);

ControlExpand.defaultProps = {
  ariaLabel: 'Expand',
  disabled: false,
  disc: false,
  handleClick: null,
};

ControlExpand.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  disc: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default ControlExpand;
